import { render } from "./App.vue?vue&type=template&id=d70e991c&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=d70e991c&lang=css"
import "./App.vue?vue&type=style&index=1&id=d70e991c&scoped=true&lang=css"

import exportComponent from "/Users/tqtifnypmb/Documents/Projects/Freelance/superpush/launching/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d70e991c"]])

export default __exports__